export default __webpack_public_path__ + "static/media/storageUnit1-afterC-1440w.990d4e4a.png";